


































import { Component, Vue } from 'vue-property-decorator'
import ContentArea from '@/components/common/ContentArea.vue'
import ProgressLine from '@/components/ProgressLine.vue'
import { TestResultOption } from '@/store/modules/walkthrough/types/types'
import PrimaryButton from '@/components/common/PrimaryButton.vue'
import HighlightText from '@/components/HighlightText.vue'
import Title from '@/components/common/page-layout/Title.vue'

@Component({
  components: {
    PrimaryButton,
    ContentArea,
    ProgressLine,
    HighlightText,
    Title
  }
})
export default class Step5 extends Vue {
  public resultOptions: TestResultOption[] = []

  private selectedOption: TestResultOption | null = null

  mounted (): void {
    this.resultOptions = this.$store.getters['walkthrough/testResultOptions']
    console.log('[Step5] mounted', { resultOptions: this.resultOptions })

    if (window.innerWidth < this.$data.mobileWidth) {
      this.$root.$on('mobile-go-back', () => {
        this.goBack()
      })
    }
  }

  public isAnyOptionSelected (): boolean {
    return !!this.selectedOption
  }

  private goBack (): void {
    this.$router.back()
  }

  get noOptionsSelected (): boolean {
    return !this.selectedOption
  }

  public setSelectedOption (selectedOption: TestResultOption): void {
    this.$store.dispatch('walkthrough/setSelectedOption', selectedOption)
    this.selectedOption = selectedOption
  }

  private destroyed (): void {
    this.$root.$off('open-screen')
    sessionStorage.removeItem('open-screen')
    if (window.innerWidth < this.$data.mobileWidth) this.$root.$off('mobile-go-back')
  }
}
